module.exports = __webpack_public_path__ + "img/logo.1632a24d.svg";